import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import * as moment from "moment"
import { StudentPortalService } from 'src/app/services/StudentPortal/student-portal.service';

@Component({
  selector: 'app-student-academics',
  templateUrl: './student-academics.component.html',
  styleUrls: ['./student-academics.component.css']
})
export class StudentAcademicsComponent implements OnInit {

  constructor(private studentPortalService: StudentPortalService, private spinnerService: Ng4LoadingSpinnerService, private lookupService: LookupService, public globalHelper: GlobalHelper) { }
  
  StudentScoreCardModel = {

    ClassID: 0,
    StudentID: 0,
    FirstName: '',
    MiddleName: '',
    LastName: '',
    ClassName: '',
    ExamMapID:0,
}
      
isCollapsed1 = true;

StudentList:any;
GetAcademics  () {
  
    this.studentPortalService.GetAcademics().subscribe((response: any) => {
         this.StudentList = response.StudentList;
       
    });
}



Print(item, PrintType) {
    
    
    var ScoreCardTypeID = item.ExamScoreCardTypeID;
    var objStudent = item.StudentID;
    var objClassID = item.ClassID;
    var objSectionID = item.SectionID;
    var StudentName = item.FirstName + " " + item.MiddleName + " " + item.LastName;
    var ClassName = item.ClassName;
    var Sections = item.SectionName;
    var ExamMapID = 0;

    var template = item.Template;
    let url = "studentreportcard12?StudentID=" + objStudent + "&ClassID=" + objClassID + "&SectionID=" + objSectionID + "&SessionID=" + item.AcademicSessionID + '&ScoreCardTypeID=' + ScoreCardTypeID + '&ExamMapID=' + ExamMapID + "&PrintType=" + PrintType;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
    
   
   
}


  ngOnInit() {
    this.GetAcademics();
  }

}
